var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00485 16.0424V15.7921C4.0416 15.0517 4.27915 14.3343 4.693 13.7138C5.38186 12.9685 5.85341 12.0552 6.0582 11.0697C6.0582 10.308 6.0582 9.53541 6.1248 8.77373C6.46887 5.10674 10.0983 2.57141 13.6834 2.57141H13.7721C17.3572 2.57141 20.9866 5.10674 21.3418 8.77373C21.4084 9.53541 21.3418 10.308 21.3973 11.0697C21.6048 12.0575 22.0759 12.9736 22.7625 13.7247C23.1794 14.3396 23.4174 15.0545 23.4506 15.7921V16.0315C23.4754 17.0263 23.1325 17.9963 22.485 18.7627C21.6295 19.6588 20.4685 20.2163 19.2219 20.3296C15.5663 20.7214 11.8781 20.7214 8.22255 20.3296C6.97733 20.2114 5.81801 19.6547 4.95938 18.7627C4.32194 17.9958 3.98359 17.0315 4.00485 16.0424Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9307 24.1163C11.5018 24.8325 12.3406 25.296 13.2613 25.4042C14.1821 25.5125 15.1088 25.2565 15.8365 24.693C16.0603 24.5263 16.2617 24.3326 16.4359 24.1163",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.1641608b13eb428ed544b6e54553d9ff.svg";
export { ForwardRef as ReactComponent };